const storename = 'KrogerCheckout';
// Actions

// Mutations
export const SET_KROGER_AUTH_CONFIG = `${storename}/setKrogerAuthConfig`;
export const SET_GO_TO_CART_OPEN = `${storename}/setGoToCart`;


// Getters
export const GET_KROGER_AUTH_CONFIG = `${storename}/getKrogerAuthConfig`;
export const GET_IS_GO_TO_CART_OPEN = `${storename}/getGoToCart`;
export const GET_SESSION_ID = `${storename}/getSessionId`;
